import React from "react";
import logo from "./logo.svg";
import image1 from "./images/challenges1.jpg";
import image2 from "./images/challenges2.jpg";
import Layout, { TAB_LOOKUP } from "./Layout";
import ArrowButton from "./ArrowButton";
import "./ChallengesScreen.scss";
import { t } from "i18next";

function ChallengesScreen() {
  return (
    <div style={{ backgroundColor: "#1B77AF", backgroundSize: "100%" }}>
      <div
        className="challenges-mobile-screen show-mobile"
        style={{ color: "white" }}
      >
        <div style={{ height: 50 }} />
        <h2 className="white-header">{t("Challenges.Challenges")}</h2>
        <p>{t("Challenges.section1")}</p>
        <img
          src={image1}
          alt="prople crossing on the stairs"
          style={{ marginTop: 20, marginBottom: 20 }}
        />

        <p>{t("Challenges.section2")}</p>
        <p>{t("Challenges.section3")}</p>
        <img
          src={image2}
          alt="prople crossing on the stairs"
          style={{ marginTop: 20 }}
        />
      </div>
      <div
        className="challenges-screen fill-absolute  hide-mobile"
        style={{ backgroundColor: "#1B77AF" }}
      >
        <div>
          <table className="container">
            <tbody>
              <tr className="cell">
                <td className="cell-text">
                  <h2 className="white-header">{t("Challenges.Challenges")}</h2>
                  <p>{t("Challenges.section1")}</p>
                </td>
                <td className="cell image1" style={{ maxHeight: "50%" }}></td>
              </tr>
              <tr className="cell">
                <td className="cell image2" style={{ maxHeight: "50%" }}></td>
                <td className="cell-text">
                  <p>{t("Challenges.section2")}</p>
                  <p>{t("Challenges.section3")}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="buttons-container">
        <ArrowButton to="/" side="left"></ArrowButton>
        <ArrowButton to="/capabilities" side="right"></ArrowButton>
      </div>
    </div>
  );
}

export default ChallengesScreen;
